module.exports = __webpack_public_path__ + "static/media/milagres-capa.a5c33832.png";